import {match, Pattern} from 'ts-pattern';

import {GridTrack} from '../types/GridTrack';
import {getSize} from './getSize';

/** Converts a design-system step to rem and unwraps `gridMinmax` / `gridRepeat` tracks. */
export function getGridTrackSize(track: GridTrack) {
  return match(track)
    .with(Pattern.number, getSize)
    .with({minmax: Pattern.string}, (value) => value.minmax)
    .with({repeat: Pattern.string}, (value) => value.repeat)
    .otherwise((keyword) => keyword);
}
